/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Popped_Out_DescriptionInputs */



/**
* | output |
* | --- |
* | "This artifact is showing in its own window so the chat has more room." |
*
* @param {Artifact_Popped_Out_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_popped_out_description = /** @type {((inputs?: Artifact_Popped_Out_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Popped_Out_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Artefakt wird in einem eigenen Fenster angezeigt, damit der Chat mehr Platz hat.")
	return /** @type {LocalizedString} */ ("This artifact is showing in its own window so the chat has more room.")
});